import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data54 from '../../data/data54.json'
import ArticleList from '../../Components/ArticleList';

const ProjectProgress: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>公益慈善项目开展情况</h1>
                <ArticleList dataId="54" data={data54 as any} />
            </div>
        } />
    );
};

export default ProjectProgress;